import { Box, Card, Grid, Typography, useMediaQuery } from "@mui/material";

function CustomCard({ children, level, title, subTitle }) {
  const md = useMediaQuery("(max-width:450px)");
  return (
    <>
      <Grid
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        sx={{
          width: md ? "calc(100% - 48px)" : "400px",
          marginX: md ? "24px" : "auto",
        }}
        height="100vh"
        gap={"16px"}
      >
        <Grid display="flex" flexDirection={"row"} alignItems={"center"}>
          {level && level < 3 && (
            <Typography sx={{ color: "var(--emr-primary)" }}>
              سامانه اردو جهادی اثر
            </Typography>
          )}
        </Grid>
        <Card
          className="rounded-xl"
          sx={{
            boxShadow: "0px 0px 4px rgba(13, 148, 136, 0.29)",
            padding: md ? "32px 12px" : "32px 30px",
            gap: "32px",
            overflow: "auto",
            width: "calc(100% - 60px)",
          }}
        >
          <Box
            display="flex"
            flexDirection={"column"}
            justifyContent={"center"}
            gap={"32px"}
          >
            <Grid
              display={"flex"}
              flexDirection={"column"}
              alignItems="center"
              gap="8px"
            >
              <Typography
                sx={{
                  color: "var(--emr-text-bold)",
                  fontSize: "16px",
                  fontStyle: "bold",
                  fontWeight: "600",
                  lineHeight: "24px",
                }}
              >
                {title}
              </Typography>
              <Typography
                sx={{
                  color: "var(--emr-text-light)",
                  fontSize: "12px",
                }}
              >
                {subTitle}
              </Typography>
            </Grid>
            {children}
          </Box>
        </Card>
      </Grid>
    </>
  );
}

export default CustomCard;
